/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_CliInputs */

const en_pc_cmp_r_cli = /** @type {(inputs: Pc_Cmp_R_CliInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automation`)
};

const zh_pc_cmp_r_cli = /** @type {(inputs: Pc_Cmp_R_CliInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动化`)
};

/**
* | output |
* | --- |
* | "Automation" |
*
* @param {Pc_Cmp_R_CliInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_cli = /** @type {((inputs?: Pc_Cmp_R_CliInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_CliInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_cli(inputs)
	return zh_pc_cmp_r_cli(inputs)
});
export { pc_cmp_r_cli as "pc.cmp.r.cli" }